module.exports = __webpack_public_path__ + "img/jenis-pengaduan.0f302045.png";